import '../styles/AthleteTabs.css';

import React, {
  useEffect,
  useRef,
} from 'react';

import { useNavigate } from 'react-router-dom';

import { sortAthletesByNumber } from '../helper';
import { Athlete } from '../types/types';

interface NewAthleteTabsProps {
  athletes: Athlete[];
  currentAthleteId?: string;
  onAthleteSelect: (athlete: Athlete) => void;
  showHomeButton?: boolean;
  sessionId?: string;
}

export default function NewAthleteTabs({ 
  athletes, 
  currentAthleteId, 
  onAthleteSelect,
  showHomeButton = false,
  sessionId
}: NewAthleteTabsProps) {
  const navigate = useNavigate();
  const tabsRef = useRef<HTMLDivElement>(null);
  
  // Sort athletes by number in ascending order
  const sortedAthletes = sortAthletesByNumber(athletes);

  const scrollActiveTabIntoView = (element: HTMLElement) => {
    element.scrollIntoView({
        behavior: 'smooth',
      block: 'nearest',
      inline: 'center'
    });
  };

  // Scroll active tab into view when component mounts or currentAthleteId changes
  useEffect(() => {
    if (!tabsRef.current) return;
    
    const activeTab = tabsRef.current.querySelector('.tab-button.active');
    if (activeTab) {
      scrollActiveTabIntoView(activeTab as HTMLElement);
    }
  }, [currentAthleteId]);
  
  return (
    <div className="athlete-tabs" ref={tabsRef}>
      {showHomeButton && sessionId && (
        <button 
          className={`tab-button home ${!currentAthleteId ? 'active' : ''}`}
          onClick={(e) => {
            navigate(`/session/${sessionId}`);
            scrollActiveTabIntoView(e.currentTarget);
          }}
        >
          <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M10 20V14H14V20H19V12H22L12 3L2 12H5V20H10Z" fill="currentColor"/>
          </svg>
        </button>
      )}
      
      {sortedAthletes.map(athlete => (
        <button
          key={athlete.id}
          className={`tab-button ${currentAthleteId === athlete.id ? 'active' : ''}`}
          onClick={(e) => {
            onAthleteSelect(athlete);
            scrollActiveTabIntoView(e.currentTarget);
          }}
        >
          <div className="athlete-tab-content">
            <span className="athlete-number">#{athlete.number}</span>
            <span className="athlete-name">{athlete.name}</span>
          </div>
        </button>
      ))}
    </div>
  );
} 